import * as Yup from 'yup'

const CustomerSchema = Yup.object({
  name: Yup.string().required('INPUT.VALIDATION.CUSTOMER.NAME'),
  mobile_number: Yup.string().required('INPUT.VALIDATION.CUSTOMER.MOBILE.NO')
    .test((value) => {
      if (!value) return false;

      const digits = value.replace(/\D/g, '');

      // ❌ reject too short or too long
      if (digits.length < 10 || digits.length > 11) {
        return false;
      }

      // ✅ allow 10-digit US number
      if (digits.length === 10) {
        return true;
      }

      // ✅ allow 11-digit ONLY if country code = 1
      if (digits.length === 11 && digits.startsWith('1')) {
        return true;
      }

      return false;
    }
    ),
  email: Yup.string().email('INPUT.VALIDATION.CUSTOMER.EMAIL.INVALID').required('INPUT.VALIDATION.CUSTOMER.EMAIL').test(
    'no-spaces',
    'INPUT.VALIDATION.CUSTOMER.EMAIL.SPACE',
    (value) => !/\s/.test(value || '')),
  type: Yup.string().required('INPUT.VALIDATION.CUSTOMER.TYPE'),
  remarks: Yup.string()
})

export default CustomerSchema;